import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

import { EPG_SURFACE_OPACITY } from "$src/core/constants/epg-grid";
import opacity from "$src/core/utils/color/opacity";
import CustomPlatform from "$src/core/utils/platform/platform";

/** Figma `border/default` = white @ 10%. */
const BORDER_OPACITY = 0.1;

const stylesheet = StyleSheet.create(({ colors, spacing, border }) => ({
  channelHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: spacing(3),
    paddingHorizontal: spacing(4),
    paddingVertical: spacing(3),
    minHeight: CustomPlatform.select({
      tv: spacing(12),
      default: spacing(14),
    }),
    marginBottom: CustomPlatform.select({
      tv: spacing(1),
      default: spacing(2),
    }),
    borderRadius: border.radius.md,
    borderWidth: border.widths.sm,
    borderColor: opacity(colors.foregroundDefault, BORDER_OPACITY),
    // Web: one subtle tint for every header (Figma); TV keeps its selected/idle split.
    variants: {
      selected: {
        true: {
          backgroundColor: CustomPlatform.select({
            tv: colors.backgroundSurface,
            default: opacity(colors.foregroundDefault, EPG_SURFACE_OPACITY),
          }),
        },
        false: {
          backgroundColor: CustomPlatform.select({
            tv: colors.backgroundDefault,
            default: opacity(colors.foregroundDefault, EPG_SURFACE_OPACITY),
          }),
        },
      },
    },
  },
  channelHeaderLogo: {
    width: spacing(12),
    height: CustomPlatform.select({
      tv: spacing(8),
      default: spacing(10),
    }),
  },
  channelHeaderTitle: {
    flex: 1,
    minWidth: 0,
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

// Width-only so the CDN preserves the logo's real aspect ratio (KAHI-268).
export const IMAGE_DIMENSIONS = {
  logo: [{ width: initialTheme.spacing(12) }],
};

export default stylesheet;
